import { ProductType, productType } from '../infrastructure/ProductType';
import { PageType } from '../infrastructure/PageType';
import { IPage, IPlaceHolder, ISpread, IEditorState } from '../infrastructure/interfaces';

function front(pageNumber: number): IPage {
  return {
    title: 'Front Cover',
    type: PageType.Front,
    number: pageNumber,
    position: 'right',
    placeholders: [{
      data: null,
      accepts: ['item'],
      type: -1,
    },
    {
      data: null,
      accepts: ['item'],
      type: -1,
    },
    {
      data: null,
      accepts: ['item'],
      type: -1,
    },
    {
      data: null,
      accepts: ['item'],
      type: -1,
    }],
  };
}

function page1(pageNumber: number): IPage {
  const page_1 = {
    title: 'Page2',
    type: PageType.Page,
    number: pageNumber,
    position: 'left',
    placeholders: [{
      data: null,
      accepts: ['item'],
      type: -1,
    },
    {
      data: null,
      accepts: ['item'],
      type: -1,
    },
    {
      data: null,
      accepts: ['item'],
      type: -1,
    }, {
      data: null,
      accepts: ['item'],
      type: -1,
    }],
  };
  return page_1;
}

function page2(pageNumber: number): IPage {
  const page_2 = {
    title: 'Page3',
    type: PageType.Page,
    number: pageNumber,
    position: 'right',
    placeholders: [{
      data: null,
      accepts: ['item'],
      type: -1,
    },
    {
      data: null,
      accepts: ['item'],
      type: -1,
    },
    {
      data: null,
      accepts: ['item'],
      type: -1,
    }, {
      data: null,
      accepts: ['item'],
      type: -1,
    }],
  };
  return page_2;
}

function back(pageNumber: number): IPage {
  return {
    title: 'Back Cover',
    type: PageType.Back,
    number: pageNumber,
    position: 'left',
    placeholders: [{
      data: null,
      accepts: ['item'],
      type: -1,
    },
    {
      data: null,
      accepts: ['item'],
      type: -1,
    },
    {
      data: null,
      accepts: ['item'],
      type: -1,
    }, {
      data: null,
      accepts: ['item'],
      type: -1,
    }],
  };
}

function postcardFront(title: string, type: PageType, pageNumber: number, position: string, placeholdersCount: number): IPage {
  const front = {
    title: title,
    type: type,
    number: pageNumber,
    position: position,
    placeholders: buildPlaceholders(placeholdersCount),
  };
  return front;
}

function postcardBack(title: string, pageNumber: number, position: string, placeholdersCount: number): IPage {
  const back = {
    title: title,
    type: PageType.Back,
    number: pageNumber,
    position: position,
    placeholders: buildPlaceholders(placeholdersCount),
  };
  return back;
}

const buildPlaceholders = (placeholdersCount: number): IPlaceHolder[] => {
  const placeholders: IPlaceHolder[] = [];
  for (let index = 0; index < placeholdersCount; index += 1) {
    placeholders.push({
      data: null,
      accepts: ['item'],
      type: 2,
    });
  }
  return placeholders;
};

export const simplePage = (pageNumber: number, placeholdersCount: number): IPage => {
  const page: IPage = {
    title: 'Front Cover',
    type: PageType.Page,
    number: pageNumber,
    position: pageNumber % 2 === 0 ? 'left' : 'right',
    placeholders: buildPlaceholders(placeholdersCount),
  };
  return page;
};

export const mapPagesToSpreads = (pages: IPage[], documentType: ProductType): ISpread[] => {
  const spreads: ISpread[] = [];
  switch (documentType) {
    case productType.Brochure:
      {
        for (let i = 0; i < pages.length / 2; i += 1) {
          let left;
          let right;
          if (pages[i].type === 0 || pages[i].type === 1) {
            left = pages[pages.length - 1 - i];
            right = pages[i];
          } else {
            left = pages[i];
            right = pages[pages.length - 1 - i];
          }
          spreads.push({ left, right, id: i });
        }
        break;
      }
    case productType.Catalog:
      {
        for (let i = 0; i < pages.length / 2; i += 1) {
          let left;
          let right;
          if (pages[i].type === 0 || pages[i].type === 1) {
            left = pages[pages.length - 1];
            left.number = pages.length;
            right = pages[i];
          } else {
            left = i === 1 ? pages[i] : pages[i + i - 1];
            right = i === 1 ? pages[i + 1] : pages[i + i];
            if (right.type === 1) {
              right = null;
            }
          }
          if (right != null) {
            spreads.push({ left, right, id: i });
          }
        }
        break;
      }
    case productType.Bulletin:
      {
        spreads.push({ left: pages[0], right: null });
        break;
      }
    case productType.Postcard:
      {
        for (let i = 0; i < pages.length / 2; i += 1) {
          let left;
          let right;
          if (pages[i].type === 0 || pages[i].type === 1) {
            left = pages[i];
            right = pages[i + 1];
          } else {
            left = pages[i + 1];
            right = pages[i + 2];
          }
          spreads.push({ left, right, id: i });
        }
        break;
      }
      case productType.Poster:
        {
          spreads.push({ left: pages[0], right: null });
          break;
        }
    default:
      break;
  }
  return spreads;
};

const generatePages = (pagesCount: number, placeholdersCount: number): IPage[] => {
  const pages = [];
  for (let index = 0; index < pagesCount - 2; index += 1) {
    pages.push(simplePage(index + 2, placeholdersCount));
  }
  pages.unshift(front(1));
  pages.push(back(pagesCount));
  return pages;
};

export const getPages = (type: ProductType, pagesCount: number): IPage[] => {
  switch (type) {
    case productType.Brochure:
      return [
        front(1),
        page1(2),
        page2(3),
        back(4),
      ];
    case productType.Catalog:
      return generatePages(pagesCount, 1);
    case productType.Bulletin:
      return [simplePage(1, 1)];
    case productType.Postcard:
      return [
        postcardFront('Front Left', PageType.Front, 1, 'left', 0),
        postcardFront('Front Right', PageType.Page, 2, 'right', 4),
        postcardBack('Back Left', 3, 'left', 0),
        postcardBack('Back Right', 4, 'right', 0),
      ];
    case productType.Poster:
      return [simplePage(1, 10)];
    default:
      break;
  }

  return [];
};

export const reorderPages = (mainPages: IPage[]) => {
  return mainPages.map((p, i) => {
    const number = i + 2;
    p.number = number;
    p.title = `Page${number}`;
    p.position = number % 2 === 0 ? 'left' : 'right';
    return p;
  });
};

export const movePages = (pages: IPage[], hoverIndex: number, dragIndex: number, editor: IEditorState) => {

  let newPagesArray = [];
  const coverPages = [pages[0], pages[pages.length - 1]];
  const mainPages = pages.filter((page) => {
    return page.type === 2;
  });
  let removedCount = 0;
  let dragIterator = 0;
  let hoverIterator = 0;

  removedCount = 2;
  dragIterator = (dragIndex * 2) - 2;
  hoverIterator = (hoverIndex * 2) - 2;

  const removedPages = mainPages.splice(dragIterator, removedCount);
  mainPages.splice(hoverIterator, 0, ...removedPages);

  newPagesArray = reorderPages(mainPages);
  newPagesArray.unshift(coverPages[0]);
  newPagesArray.push(coverPages[1]);

  return newPagesArray;
};



// WEBPACK FOOTER //
// ./src/services/PageService.ts